// VALM CUSTOM: Format Yotpo's live review count without replacing its data or click behavior.
(() => {
  const reviewLabel = document.currentScript?.dataset.reviewLabel;
  if (!reviewLabel) return;

  const widgetSelector = '.yotpo-widget-instance[data-yotpo-section-id="product"]';
  const observed = new WeakSet();
  const formatCount = widget => {
    widget.querySelectorAll('.yotpo-sr-bottom-line-text--right-panel').forEach(label => {
      const count = label.textContent.trim().match(/^\(\s*([\p{N}\s.,]+)\s*\)$/u)?.[1].trim();
      if (count) label.textContent = `${count} ${reviewLabel}`;
    });
  };

  const initialize = root => {
    const widgets = [...root.querySelectorAll(widgetSelector)];
    if (root.matches?.(widgetSelector)) widgets.unshift(root);
    widgets.forEach(widget => {
      if (observed.has(widget)) return;
      observed.add(widget);
      formatCount(widget);
      const observer = new MutationObserver(() => formatCount(widget));
      observer.observe(widget, { childList: true, characterData: true, subtree: true });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
